
const FirstStepWizardTextField = ({value, state, label, isOptional, type, handleInput, isEmpty}) => {
  const borderColor = !isEmpty ? "border-green-600" :
    isOptional ? "border-gray-600" :
      "border-red-600";

  return (
  <input
      value={value}
      autoComplete="none"
      type={type}
      onChange={(e) => handleInput(state, e.target.value)}
      className={`focus:outline-none p-2 w-full border-2 ${borderColor} `}
      placeholder={label}
      />
  )
}

export default FirstStepWizardTextField;
